/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SignatureType {
    ELECTRONIC = 'ELECTRONIC',
    WET_INK = 'WET_INK',
    REVIEW = 'REVIEW',
}
